<template>
  <div class="footer">
    2024- &copy; 城市轨道交通运营管理实验平台
  </div>
  <WebSite></WebSite>
</template>

<script>
import WebSite from './WebSite.vue';
export default {
  name: 'FooterLayout',
  components: {
    WebSite,
  },
}
</script>
<style lang="less" scoped>
  .footer{
    text-align:center;
    background-color: rgba(78, 71, 71, 1);
    color: #fff;
    font-size: 12px;
    padding: 8px 0;
  }
</style>
